{
  "version": 1,
  "asset_id": "e5ace7ef-b9bc-496c-bf92-c532e7ff544b",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/e5ace7ef-b9bc-496c-bf92-c532e7ff544b/lecanto-metal-roof-before-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/e5ace7ef-b9bc-496c-bf92-c532e7ff544b/lecanto-metal-roof-before-1320w.avif",
  "original_filename": "lecanto-metal-roof-before-1320w.avif",
  "size": 163949,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
